<template>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.organization.header')"
        :selected-count="selectedOrganizationCount"
    >
        <OrganizationFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin || hasMultipleClientCompanies"
        :title="t('projectclient.projectlist.topbar.filters.company.header')"
        :selected-count="selectedCompanyCount"
    >
        <CompanyFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper size="medium" :title="t('projectclient.projectlist.topbar.filters.status.header')" :selected-count="selectedStatusCount">
        <StatusFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper size="medium" :title="t('projectclient.projectlist.topbar.filters.action.header')" :selected-count="selectedActionsCount">
        <ActionFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper :title="t('projectclient.projectlist.topbar.filters.freelancer.header')" :selected-count="selectedFreelancerCount">
        <FreelancerFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin || isAdminOfAClientCompany"
        :title="t('projectclient.projectlist.topbar.filters.projectowner.header')"
        :selected-count="selectedOwnerCount"
    >
        <OwnerFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.contracttype.header')"
        :selected-count="selectedContractTypeCount"
    >
        <ContractTypeFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.verticalType.header')"
        :selected-count="selectedVerticalCount"
    >
        <VerticalTypeFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.opportunityType.header')"
        :selected-count="selectedOpportunityTypeCount"
    >
        <OpportunityTypeFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper :title="t('projectclient.projectlist.topbar.filters.startdate.header')" :selected-count="selectedStartDateCount">
        <StartDateFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper :title="t('projectclient.projectlist.topbar.filters.enddate.header')" :selected-count="selectedEndDateCount">
        <EndDateFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.renewalStatus.header')"
        :selected-count="selectedRenewalStatusCount"
    >
        <RenewalStatusFilter />
    </FilterPopinWrapper>

    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.companymanager.header')"
        :selected-count="selectedCompanyManagerCount"
    >
        <CompanyManagerFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.finopsmanager.header')"
        :selected-count="selectedFinOpsManagerCount"
    >
        <FinOpsManagerFilter />
    </FilterPopinWrapper>
    <FilterPopinWrapper
        v-if="isPlatformAdmin"
        :title="t('projectclient.projectlist.topbar.filters.customersuccessmanager.header')"
        :selected-count="selectedCustomerSuccessManagerCount"
    >
        <CustomerSuccessManagerFilter />
    </FilterPopinWrapper>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useUserStore} from '@common/stores';
    import {
        ActionFilter,
        CompanyFilter,
        StartDateFilter,
        EndDateFilter,
        FreelancerFilter,
        OrganizationFilter,
        OwnerFilter,
        StatusFilter,
        CompanyManagerFilter,
        FinOpsManagerFilter,
        CustomerSuccessManagerFilter,
        ContractTypeFilter,
        VerticalTypeFilter,
        OpportunityTypeFilter,
        RenewalStatusFilter,
        useProjectsListStore,
    } from '@features/projects-list';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterPopinWrapper from './FilterPopinWrapper.vue';

    const {t} = useTranslation();

    const userStore = useUserStore();
    const {isPlatformAdmin} = storeToRefs(userStore);

    const projectListStore = useProjectsListStore();
    const {searchParams, isAdminOfAClientCompany, hasMultipleClientCompanies} = storeToRefs(projectListStore);

    const selectedActionsCount = computed(() => searchParams.value.actions?.length ?? 0);
    const selectedFreelancerCount = computed(() => searchParams.value.freelancers?.length ?? 0);
    const selectedCompanyCount = computed(() => searchParams.value.companies?.length ?? 0);
    const selectedOrganizationCount = computed(() => searchParams.value.organizations?.length ?? 0);
    const selectedOwnerCount = computed(() => searchParams.value.owners?.length ?? 0);
    const selectedStatusCount = computed(() => searchParams.value.status?.length ?? 0);
    const selectedCompanyManagerCount = computed(() => searchParams.value.companyManagers?.length ?? 0);
    const selectedFinOpsManagerCount = computed(() => searchParams.value.finOpsManagers?.length ?? 0);
    const selectedCustomerSuccessManagerCount = computed(() => searchParams.value.customerSuccessManagers?.length ?? 0);
    const selectedContractTypeCount = computed(() => searchParams.value.contractTypes?.length ?? 0);
    const selectedVerticalCount = computed(() => searchParams.value.verticalTypes?.length ?? 0);
    const selectedOpportunityTypeCount = computed(() => searchParams.value.opportunityTypes?.length ?? 0);
    const selectedRenewalStatusCount = computed(() => searchParams.value.renewalStatuses?.length ?? 0);
    const selectedStartDateCount = computed(() => {
        const {startDateFrom, startDateTo} = searchParams.value;
        return [startDateFrom, startDateTo].filter((f) => !!f).length;
    });
    const selectedEndDateCount = computed(() => {
        const {endDateFrom, endDateTo} = searchParams.value;
        return [endDateFrom, endDateTo].filter((f) => !!f).length;
    });
</script>
